import { Component, Input, OnDestroy } from '@angular/core';
import { ButtonOptions } from '@usitsdasdesign/dds-ng/button';
import { ModalService } from '@usitsdasdesign/dds-ng/modal';
import { Column } from '@usitsdasdesign/dds-ng/shared';
import {
  CompleteReviewPopUpTableHeader,
  SecondaryButton,
} from '../submission-common-section.helper';
import {
  SubmissionApprovers,
  IntakeSubmissionDeatilsCommonSectionWorkflowSelectedDocumentsModal,
} from '../../../../common/models/intake-submission-details-common-section.model';
import { ProgressIndicatorService } from '../../../../common/services/progress-indicator.service';
import { SubmissionService } from '../../../../http/intake/submission.service';
import { Subject, takeUntil } from 'rxjs';
import {
  IntakeDocumentTableModel,
  IntakeSelectableDocumentTableModel,
} from '../../../../common/models/intake-document-table.model';
import { DocumentStatus } from '../../../constants/document-status.enum';
import { HttpErrorResponse } from '@angular/common/http';
import { IntakeConstant } from '../../../constants/intake.constant';

@Component({
  selector: 'app-document-selection-popup',
  templateUrl: './document-selection-popup.component.html',
  styleUrl: './document-selection-popup.component.less',
})
export class DocumentSelectionPopupComponent implements OnDestroy {
  @Input() submissionID: string = IntakeConstant.EMPTY_SPACE;
  @Input() rowDetails!: SubmissionApprovers;
  @Input() submissionTypeId: number = 0;

  isAllSelected: boolean = false;
  selectedRowCount: number = 0;
  submissionIdList: number[] = [];
  cancelButton: ButtonOptions = SecondaryButton;
  docToShow: IntakeSelectableDocumentTableModel[] = [];
  public docMetaData: IntakeDocumentTableModel[] = [];
  public sampleColumns: Column[] = CompleteReviewPopUpTableHeader;

  readonly #unsubscriber$: Subject<void> = new Subject<void>();

  constructor(
    private readonly modalService: ModalService,
    private readonly submissionService: SubmissionService,
    private readonly progressIndicatorService: ProgressIndicatorService
  ) {}

  ngOnInit(): void {
    this.loadDocumentTableData();
  }

  public toggleRow(rowData: IntakeSelectableDocumentTableModel): void {
    rowData.selected = !rowData.selected;
    if (rowData.selected) {
      this.submissionIdList.push(rowData.submissionDocumentId);
    } else {
      this.submissionIdList = this.submissionIdList.filter(
        (doc: number) => doc !== rowData.submissionDocumentId
      );
    }
    this.#checkSelectedRow(this.docToShow);
  }

  public selectAllRows(
    status: boolean,
    data: IntakeSelectableDocumentTableModel[]
  ): void {
    data.forEach((item) => (item.selected = status));
    this.#checkSelectedRow(this.docToShow);
    if (status) {
      this.submissionIdList = [];
      for (let i in this.docToShow) {
        this.submissionIdList.push(this.docToShow[i].submissionDocumentId);
      }
    } else this.submissionIdList = [];
  }

  #checkSelectedRow(data: IntakeSelectableDocumentTableModel[]): void {
    this.selectedRowCount = data.filter((row) => row.selected).length;
    this.isAllSelected = data.length === this.selectedRowCount;
  }

  close(showToastMessage: boolean): void {
    this.modalService.close(showToastMessage);
  }

  submitSelectedDoc(): void {
    const submissionList: number[] = this.docToShow
      .filter(
        (doc) =>
          doc.selected &&
          doc.documentStatus !== DocumentStatus.FinalArchiveReadyVersion &&
          this.submissionIdList.includes(doc.submissionDocumentId)
      )
      .map((doc) => doc.submissionDocumentId);

    const saveSelectedDocuments: IntakeSubmissionDeatilsCommonSectionWorkflowSelectedDocumentsModal =
      {
        SubmissionDocumentId: submissionList,
        RMEmployeeid: this.rowDetails.reviewerId,
        Email: this.rowDetails.emailId,
        SubmissionId: +this.submissionID,
        DocumentStatusId: 2,
        SubmissionTypeId: this.submissionTypeId,
      };
    this.progressIndicatorService.show();
    this.submissionService
      .updateRMStatus(saveSelectedDocuments)
      .pipe(takeUntil(this.#unsubscriber$))
      .subscribe({
        next: () => {
          this.progressIndicatorService.hide();
          this.submissionIdList = [];
          this.close(true);
        },
        error: (err) => {
          this.progressIndicatorService.hide();
          console.error('An error occurred while sending the data ', err);
        },
      });
  }

  loadDocumentTableData(): void {
    if (this.submissionID && +this.submissionID != 0) {
      this.submissionService
        .getDocumentTableData(+this.submissionID)
        .pipe(takeUntil(this.#unsubscriber$))
        .subscribe({
          next: (data: any) => {
            this.docMetaData = data;
            this.docToShow = data.filter(
              (doc: IntakeSelectableDocumentTableModel) =>
                doc.documentStatus !== 'RM Reviewed'
            );
            for (let i in this.docToShow) this.docToShow[i].selected = false;
          },
          error: (err: HttpErrorResponse) => {
            console.error('An error occurred during fetching the data ', err);
          },
        });
    }
  }

  ngOnDestroy(): void {
    this.#unsubscriber$.next();
    this.#unsubscriber$.complete();
  }
}
